export default {
  setPatient({ commit }, patient) {
    commit('updatePatient', patient)
  },

  setOrderDetails({ commit }, orderDetails) {
    commit('updateOrderDetails', orderDetails)
  },

  setMedicines({ commit }, selectedMedicines) {
    commit('updateSelectedMedicines', selectedMedicines)
  },

  setShippingFee({ commit }, shippingFee) {
    commit('updateShippingFee', shippingFee)
  },

  setShippingDate({ commit }, shippingDate) {
    commit('updateShippingDate', shippingDate)
  },

  setState({ commit }, state) {
    commit('updateState', state)
  },

  setCity({ commit }, city) {
    commit('updateCity', city)
  },



  setDeliveryPoint({ commit }, deliveryPoint) {
    commit('updateDeliveryPoint', deliveryPoint)
  },
  setDeliveryPointName({ commit }, deliveryPointName) {
    commit('updateDeliveryPointName', deliveryPointName)
  },
  setDeliveryPointAddress({ commit }, deliveryPointAddress) {
    commit('updateDeliveryPointAddress', deliveryPointAddress)
  },
  setAppointmentDate({ commit }, appointmentDate) {
    commit('updateAppointmentDate', appointmentDate)
  },



  setSchedule({ commit }, schedule) {
    commit('updateSchedule', schedule)
  },

  setScheduleName({ commit }, scheduleName) {
    commit('updateScheduleName', scheduleName)
  },

  setProvider({ commit }, provider) {
    commit('updateProvider', provider)
  },

  setAddress({ commit }, address) {
    commit('updateAddress', address)
  },

  setPhone({ commit }, phone) {
    commit('updatePhone', phone)
  },

  setCellPhone({ commit }, cellPhone) {
    commit('updateCellPhone', cellPhone)
  },

  setObservations({ commit }, observations) {
    commit('updateObservations', observations)
  },

  setnameNomenclature({ commit }, nameNomenclature) {
    commit('updatenameNomenclature', nameNomenclature)
  },

  setnumberOne({ commit }, numberOne) {
    commit('updatenumberOne', numberOne)
  },

  setnumberTwo({ commit }, numberTwo) {
    commit('updatenumberTwo', numberTwo)
  },

  setnumberThree({ commit }, numberThree) {
    commit('updatenumberThree', numberThree)
  },
  //sasdfgsdfghsdfg
  setpropertyType({ commit }, propertyType) {
    commit('updatepropertyType', propertyType)
  },

  setcomplementOne({ commit }, complementOne) {
    commit('updatecomplementOne', complementOne)
  },

  setblockOrInside({ commit }, blockOrInside) {
    commit('updateblockOrInside', blockOrInside)
  },

  setcomplementTwo({ commit }, complementTwo) {
    commit('updatecomplementTwo', complementTwo)
  }
}
